<template>
    <div id="esp_settings_view_participants" class="m-auto pt-12" :style="`max-width:400px`">
        <v-text-field 
            v-for="(p,index) in participants" 
            :key="index"
            required
            filled
            hide-details
            v-model="p.name"
            :placeholder="$t('welcomeParticipantsPlaceholder')"
            rounded
            append-outer-icon="mdi-close"
            class="pt-2 settings-view-participants"
            @input="onChangedInput"
            @click:append-outer="onRemoveParticipant(index)">
        </v-text-field>
    </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin';
    export default {
        mixins: [layoutMixin],
        props:{
            value:{
                type:Boolean,
                default:false
            },
            changeFoto:{
                type:Boolean,
                default:false
            },
            changeName:{
                type:Boolean,
                default:false
            },
            isMobile:{
                type:Boolean,
                default:false
            },
            color: {},
            backgroundColor: {}
        },
        data() {
            return {
                valid:false,
                participants:[],
                colorValue: this.color,
                backgroundColorValue: this.backgroundColor
            }
        },
        watch:{
            value(val){
                this.valid=val;
            }
        },
        methods:{
            addParticipant(name){
                this.participants.push({
                    name:name
                });
            },
            removeParticipant(index){
                if(this.participants){
                    if(this.participants.length>1){
                        this.participants.splice(index, 1);
                    }else{
                        this._.first(this.participants).name="";
                    }
                }
            },
            addDummyParticipantField(){
                let last = this._.last(this.participants);
                if(this._.isEmpty(last) || (last && this._.isString(last.name) && last.name.trim()!="") ){
                    this.addParticipant("");
                }
            },
            onRemoveParticipant(index){
                this.removeParticipant(index);
                this.onChangedInput();
            },
            onChangedInput(){
                this.$nextTick(()=>{
                    
                    this.addDummyParticipantField();
                    this.valid=!this._.isEmpty(this.participants) && this._.filter(this.participants,(p)=>{
                        return (p && this._.isString(p.name) && p.name.trim()!="")
                    }).length>0;

                    this.emitComplete();
                    this.$emit('input',this.valid);
                });

            },
            emitComplete(){
                if(this.valid){
                    let finalParticipants=this._.map(this._.filter(this.participants,(p)=>{return p.name.trim()!=""}),(p)=>{return p.name});
                    this.$emit('complete',finalParticipants);
                }
            },
            assignPseudoElementStyle() {
                this.colorValue = this.theme.textColor;
                this.backgroundColorValue = this.theme.backgroundColor;
                document.documentElement.style.setProperty('--color', this.colorValue);
                document.documentElement.style.setProperty('--background-color', this.backgroundColorValue);
             },
        },
        mounted() {
            this.addDummyParticipantField();
            this.assignPseudoElementStyle();
        },
    }
</script>

<style lang="scss">
     #esp_settings_view_participants {
        .settings-view-participants .v-input__control > .v-input__slot {
            // background-color: var(--background-color);
            border: 2px solid var(--color);
        }
        .settings-view-participants.v-input__control {
            border-bottom-color: var(--color) !important;
            border-left-color: var(--color) !important;
            border-right-color: var(--color) !important;
            border-top-color: var(--color) !important;
        }

        .settings-view-participants input::placeholder {
            color: var(--color) !important;
            opacity: 1;
        }

        .custom-label-color .v-label {
            color: var(--color) ;
            opacity: 1;
        }

        .settings-view-participants input,
          .custom-label-color input{
            color: var(--color)!important;
            caret-color: var(--color);
        }
       .v-icon {
            color: var(--color) !important;
        }
  
    }
  

</style>